// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

// Shared New Business Application template types — the single source of truth for
// the Admin UI (platform-scope authoring) and Advisor UI (brokerage-override
// authoring) editors. See docs/specs/new-business-application-prd.md §5.6/§5.7.

/** A single coordinate-overlay binding placed on the provider form PDF. */
export interface AnnotationBinding {
  id: string;
  page: number;
  x: number;
  y: number;
  width?: number | null;
  fontSize?: number | null;
  align?: string | null;
  /** TEXT | DATE | MONEY | MULTILINE | CHECK | SIGNATURE */
  fieldType: string;
  /** data key or param.<id>; absent for SIGNATURE */
  source?: string | null;
  checkWhen?: string | null;
}

/** A provider application-form template (PLATFORM default or BROKERAGE override). */
export interface NewBusinessTemplate {
  id?: string;
  scope?: string;
  brokerageId?: string | null;
  providerId: string;
  providerName?: string;
  providerLogoUrl?: string;
  productId: string;
  productName?: string;
  category?: string;
  currencyCode: string;
  isActive?: boolean;
  notes?: string | null;
  hasPdf?: boolean;
  annotationMap?: AnnotationBinding[];
  signatureRegionCount?: number;
  paramSchema?: Record<string, unknown>;
  createdAt?: string;
  updatedAt?: string;
}

export interface BindingCatalogueEntry {
  key: string;
  label: string;
  suggestedFieldType?: string;
}

export interface BindingCatalogueGroup {
  name: string;
  entries: BindingCatalogueEntry[];
}

export interface BindingCatalogue {
  groups: BindingCatalogueGroup[];
}

/** The overlay field types an admin/advisor can assign to a binding. */
export const NB_FIELD_TYPES = ['TEXT', 'DATE', 'MONEY', 'MULTILINE', 'CHECK', 'SIGNATURE'] as const;
